import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M304.3 89.2 128.5 190.8l191.8 110.7 191.9-110.7L336.3 89.2c-9.9-5.7-22.1-5.7-32 0zM112.5 218.5v203c0 11.4 6.1 22 16 27.7l175.8 101.5V329.2L112.5 218.4zm223.8 332.3 175.9-101.6c9.9-5.7 16-16.3 16-27.7v-203L336.4 329.3v221.5zm-48-489.3c19.8-11.4 44.2-11.4 64 0L528.2 163c19.8 11.4 32 32.6 32 55.4v203c0 22.9-12.2 44-32 55.4L352.3 578.5a64.158 64.158 0 0 1-64 0L112.5 477c-19.8-11.4-32-32.6-32-55.4v-203c0-22.9 12.2-44 32-55.4L288.3 61.5z" }, null, -1)
  ]))]))
}
export default { render: render }